import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'
import { itv } from '../../../assets/newsOutlets'
import Arrow15 from '../../../assets/arrow4'

export const ItvBox = () => {
    return (
        <div className={styles.itvBoxMobile}>
            <div className={styles.itvContainer}>
                <span>
                    <b>As seen on</b>
                </span>
                <img src={itv} alt="ITV" className={styles.itvLogo} />
            </div>
            <div className={styles.arrowContainer}>
                <Arrow15 />
            </div>
        </div>
    )
}

export default ItvBox
